import React, { useEffect, useRef } from 'react';
import { NewUserRequirementsViewContextProvider } from './contexts/NewUserRequirementsViewContext';
import RequirementsList from './RequirementsList/RequirementsList';
import { translations } from './constants';
import ActionButtons from './ActionButtons/ActionButtons';
import { useModal } from 'hooks/useModal';
import IdentificationMoreDetailsModal from './IdentificationMoreDetailsModal/IdentificationMoreDetailsModal';
import { formatText } from 'core/i18n';
import './NewUserRequirementsView.scss';
import WalletImg from 'assets/images/acount-checking-account-open-120.png';
import { isCountrySpain } from 'utilities/multiLanguageHelper';
import { doTagClickMoreDetailsButton, doTagPage } from './tagging';
import { Header } from 'components/header/header';
import { ProcessAlreadyStartedModal } from './ProcessAlreadyStartedModal/ProcessAlreadyStartedModal';
import { doTagProcessAlreadyStartedModal } from './ProcessAlreadyStartedModal/tagging';

const supportsHas = CSS.supports('selector(:has(*))');
const NewUserRequirementsView = ({ onClickStartProcess }) => {
    const isSpain = isCountrySpain();

    const { isOpen: isMoreDetailsModalOpen, toggleModal: toggleMoreDetailsModal } = useModal();
    const { isOpen: isProcessAlreadyStartedModalOpen, toggleModal: toggleProcessAlreadyStartedModal } = useModal();
    const tagPageFired = useRef(false);

    const handleToggleMoreDetailsModal = () => {
        !isMoreDetailsModalOpen && doTagClickMoreDetailsButton();
        toggleMoreDetailsModal(!isMoreDetailsModalOpen);
    };

    const handleToggleProcessAlreadyStartedModal = () => {
        !isProcessAlreadyStartedModalOpen && doTagProcessAlreadyStartedModal();
        toggleProcessAlreadyStartedModal(!isProcessAlreadyStartedModalOpen);
    };

    useEffect(() => {
        !tagPageFired.current && doTagPage();
        tagPageFired.current = true;
    }, []);

    return (
        <>
            <Header bigHeader={false} sticky={supportsHas}>
                <span className="prospects-content--header-icon icons--icon-jointholder" />
            </Header>
            <NewUserRequirementsViewContextProvider
                {...{
                    isSpain,
                    isMoreDetailsModalOpen,
                    handleToggleMoreDetailsModal,
                    isProcessAlreadyStartedModalOpen,
                    handleToggleProcessAlreadyStartedModal,
                    onClickStartProcess,
                }}
            >
                <div className="new-user-requirements">
                    <aside className="image">
                        <img src={WalletImg} alt="requirements wallet" />
                    </aside>
                    <main>
                        <section>
                            <h3>{formatText(translations.NEW_USER_REQUIREMENTS_VIEW_TITLE)}</h3>
                            <RequirementsList />
                        </section>
                        <footer>
                            <ActionButtons />
                        </footer>
                    </main>
                </div>
                <IdentificationMoreDetailsModal />
                <ProcessAlreadyStartedModal />
            </NewUserRequirementsViewContextProvider>
        </>
    );
};

export default NewUserRequirementsView;
